import { graphql } from '@e-socna/data-layer';

// The counts shown by the entries of a mission space, for the mission of the
// page and the collaboration of a sub-mission alike.
export const NavigationContext_MissionSpaceCounts_Mission_Fragment = graphql(`
  fragment NavigationContext_MissionSpaceCounts_Mission_Fragment on Mission {
    businessEventIds
    fileDirectory {
      files {
        _id
        hideInFileExplorer
      }
    }
    reportInfos {
      stateId
    }
    servicesInfo {
      totalCalculation {
        result {
          discountedAmountExcludingVat {
            currencyId
            value
          }
        }
      }
    }
    subMissionIds
    toolkitsInfo {
      enabledToolkitIds
    }
  }
`);

export const NavigationContext_MissionSpaceInfo_Mission_Fragment = graphql(`
  fragment NavigationContext_MissionSpaceInfo_Mission_Fragment on Mission {
    accountingInfo {
      stateId
    }
    compositeMission {
      _id
      accountingInfo {
        stateId
      }
      quotationInfo {
        stateId
      }
      stateId
      ...NavigationContext_MissionSpaceCounts_Mission_Fragment
    }
    folderId
    _id
    kind
    stateId
    quotationInfo {
      stateId
    }
    reportInfos {
      stateId
    }
    workflowId
    ...NavigationContext_MissionSpaceCounts_Mission_Fragment
  }
`);
